<template>
    <v-data-table
      :headers="tableHeaders"
      :items="computedItems"
      item-key="id"
      :search="search"
      :custom-filter="filterFunction"
      class="mt-4"
      show-group-by
    >
      <template v-slot:top="{}">
        <v-row justify="end" align="baseline" align-content="center">
          <v-col sm="8" md="9">
            <v-text-field
              v-model="search"
              label="Search"
              dense
              clearable
            />
          </v-col>
          <v-spacer />
          <v-col>
            <v-btn
              rounded
              color="primary"
              @click="$emit('ADD')"
            >
              <v-icon>mdi-plus</v-icon>
              {{ $t('dictionaries.newItem') }}
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:group.header="{ group, groupBy, isOpen, toggle, remove }">
        <td colspan="2" class="text-start ma-2">
          <v-btn icon small @click="toggle">
            <v-icon>{{isOpen ? 'mdi-minus' : 'mdi-plus'}}</v-icon>
          </v-btn>
          {{groupBy[0] === 'projectName' ? 'Project' : 'User' }}: {{group}}
          <v-btn icon small @click="remove">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </td>
      </template>
      <template v-slot:item.actions="{ item }">
        <SubmitButton
          icon="mdi-delete"
          small
          @click="$emit('DELETE', item.id)"
        />
      </template>
    </v-data-table>
</template>

<script>
export default {
  name: 'UsersAccessTable',
  props: {
    headers: Array,
    items: Array,
    title: String
  },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    computedItems () {
      const filtredItems = this.items.filter(i => i.project !== undefined)

      return filtredItems.map(i => ({
        ...i,
        projectName: i.project?.code ? `${i.project.name} (${i.project.code})` : i.project.name,
        userName: i.user?.displayName
      }))
    },
    tableHeaders () {
      return [
        { text: this.$tc('dictionaries.user', 1), value: 'userName' },
        { text: this.$tc('contract.project.OFF', 1), value: 'projectName' },
        { text: '', value: 'actions', sortable: false, groupable: false }
      ]
    }
  },
  methods: {
    filterFunction (value, search) {
      return value ? value.toUpperCase().includes(search.toUpperCase()) : false
    }
  }
}
</script>
